import React, { useEffect, useState } from "react"
import '../styles.css'
import { InputGroup, Form } from "react-bootstrap";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import blogFetch from "../../../axios/config";
import Loading from "../../../components/Loading";
import { DateFmt, FormatDate } from "../../../utils/DataUtils";

export default function ModalHistoricPieces({
    show,
    setShow,
    selectedMold
}) {

    const [pieces, setPieces] = useState([]);
    const [search, setSerach] = useState("");
    const [loading, setLoading] = useState();

    useEffect(() => {
        const getPiecesHistoric = async () => {
            setLoading(true)
            try {
                const { data } = await blogFetch.get(`/ISAGA_VagoesFornosPecas/historicMolds/${selectedMold.molde_Key}`)
                setPieces(data)

            } catch (error) {
                console.error(error)
            }
            finally {
                setLoading(false)
            }
        }
        getPiecesHistoric()
    }, [selectedMold])

    const handleClick = () => {
        setShow(false)
        setPieces([])
        setSerach("")
    }

    const filteredPieces = pieces.filter(
        ({ ordem_Serial }) =>
            ordem_Serial.toString().toLowerCase().includes(search.toLowerCase())
    )

    return <>
        <Modal size="lg"
            show={show}>
            <Modal.Header>
                <h3 className="title_tables">
                    {`HISTÓRICO DE PEÇAS DO LOTE: ${selectedMold.molde_Lote}`}
                </h3>
            </Modal.Header>
            <Modal.Body>

                <InputGroup className="my-3">
                    <Form.Control
                        placeholder="Buscar Peça - Ordem Serial"
                        value={search}
                        onChange={({ target }) => setSerach(target.value)}
                    />
                </InputGroup>

                {!loading ?
                    <div>
                        {pieces.length > 0 ? (
                            <div className="filawrap">
                                <table className="tableFixHead table text-centetendeur">
                                    <thead>
                                        <tr>
                                            <th>ORDEM SERIAL</th>
                                            <th>MOLDE DESCRIÇÃO</th>
                                            <th>VEÍCULO</th>
                                            <th>ÚLTIMO APONTAMENTO</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredPieces.map((item) => (
                                            <tr key={item.ordem_Serial}>
                                                <td>{item.ordem_Serial}</td>
                                                <td>{item.molde_Descricao}</td>
                                                <td>{item.ordem_VehDesc}</td>
                                                <td>{DateFmt (item.ordem_DtUltApont)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <h3 className="title_tables">
                                NÃO FORAM ENCONTRADO PEÇAS
                            </h3>
                        )}
                    </div>
                    : (<Loading />)}

            </Modal.Body>
            <Modal.Footer>
                <Button onClick={() => handleClick()}>
                    FECHAR
                </Button>
            </Modal.Footer>
        </Modal>
    </>
}

